import { IContact } from "@/models/contacts/contact.types"
import { CallTraceAuditConfirmedStatus } from "./gdprFields.parser"
import { IGdprField } from "./gdprFields.types"

export class GdprField implements IGdprField {
  accountNumber: string
  confirmStatus: CallTraceAuditConfirmedStatus
  dataUpdated: string
  gdprType: keyof IContact
  id: number

  constructor(accountNumber, confirmStatus, dataUpdated, gdprType, id) {
    this.accountNumber = accountNumber
    this.confirmStatus = confirmStatus
    this.dataUpdated = dataUpdated
    this.gdprType = gdprType
    this.id = id
  }
}
